<ws-modal-wrapper headerLabel="Tax Bill Transmit Delivery Details"
                  [cancelLabel]="params.editMode ? 'Cancel' : 'Close'"
                  [hideSave]="!params.editMode"
                  saveLabel="OK"
                  (save)="save()"
                  (cancel)="close()"
                  data-qa="tax-bill-transmit-modal">
    <tabset #paymentDetailsTabs>
        <tab heading="Feed Specifications" id="feed-specs-tab" data-qa="tax-bill-transmit-feed-specs-tab">
            <delivery-details-feed-specs [editMode]="params.editMode"
                                         [(feedSpecifications)]="params.feedSpecifications"
                                         [(clientAbbreviation)]="params.clientAbbreviation"
                                         [entity]="params.entity"
                                         [dataHubEnabled]="params.dataHubEnabled"
                                         [shouldDisplayDataHub]="shouldDisplayDataHub"
                                         [isBillPay]="params.isBillPay">
            </delivery-details-feed-specs>
        </tab>
        @if (shouldDisplayPaymentBatch) {
            <tab heading="Payment Batch Workflow" id="payment-batch-tab" data-qa="tax-bill-transmit-payment-batch-tab">
                <payment-batch-workflow
                    [editMode]="params.editMode"
                    [entity]="params.entity"
                    [userSearchInstanceId]="params.userSearchInstanceId"
                    [currentPaymentBatchData]="params.currentPaymentBatchData"
                    [dataHubEnabled]="params.dataHubEnabled"
                    (setEfAction)="paymentBatchData.efAction = $event"
                    (setCurrentData)="paymentBatchData.currentData = $event"
                    [shouldDisplayDataHub]="shouldDisplayDataHub"
                    (setIsDirty)="paymentBatchData.isDirty = $event"
                    data-qa="tax-bill-transmit-payment-batch-workflow">
                </payment-batch-workflow>
            </tab>
        }
    </tabset>
</ws-modal-wrapper>
